import { render, staticRenderFns } from "./indexParent.vue?vue&type=template&id=45f5df72&scoped=true"
import script from "./indexParent.vue?vue&type=script&lang=js"
export * from "./indexParent.vue?vue&type=script&lang=js"
import style0 from "./indexParent.vue?vue&type=style&index=0&id=45f5df72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5df72",
  null
  
)

export default component.exports